export default __webpack_public_path__ + "static/media/pwd_type2.d23da4d2.png";